import styled, { css } from 'styled-components';

export const Popover = styled.div<{
  position: 'bottom' | 'top' | 'center';
  backgroundColor?: string;
}>`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ backgroundColor }) => backgroundColor || '#ff4040'};
  color: white;
  padding: 20px 24px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  z-index: 1000;
  opacity: 0;
  transition: all 0.4s ease;
  width: 80%;
  margin: 0 auto;
  text-align: center;

  ${({ position }) =>
    position === 'bottom' &&
    css`
      bottom: -100px;
      &.visible {
        bottom: 32px;
        opacity: 1;
      }
    `}

  ${({ position }) =>
    position === 'top' &&
    css`
      top: -100px;
      &.visible {
        top: 32px;
        opacity: 1;
      }
    `}

  ${({ position }) =>
    position === 'center' &&
    css`
      top: 50%;
      transform: translate(-50%, -50%);
      &.visible {
        opacity: 1;
      }
    `}
`;
